import { useQuery } from "@tanstack/react-query";
import { router } from "expo-router";
import { observer } from "mobx-react";
import React from "react";
import { Layout } from "~/components/Layout";
import { Screen } from "~/components/Screen";
import { ButtonV2 } from "~/components/V2/Button";
import { ErrorViewV2 } from "~/components/V2/ErrorViewV2";
import { Container } from "~/components/V2/PageContainer";
import { PetCard } from "~/components/V2/SpeciesCard";
import { SpinnerV2 } from "~/components/V2/SpinnerV2";
import { View } from "~/components/V2/View";
import { useStore } from "~/mobx/utils/useStore";
import { styleConstantsV2 } from "~/style/styleConstantsV2";
import { assert } from "~/utils/assert";

export const MyPetsScreen = observer(function MyPetsScreen() {
  const store = useStore();
  const activeUser = store.authStore.activeUser;

  assert(activeUser, "Active user should be defined");

  const query = useQuery({
    queryKey: ["myPets", activeUser.id],
    queryFn: async () => {
      const result = await store.petsStore.getMyPets();
      return result;
    },
  });

  if (query.isLoading) {
    return (
      <Screen withBottomInset withTopInset preventScroll>
        <View flex centerContent>
          <SpinnerV2 />
        </View>
      </Screen>
    );
  }

  if (query.isError) {
    return (
      <Screen withBottomInset withTopInset preventScroll>
        <View flex centerContent paddingHorizontal24>
          <ErrorViewV2
            error={query.error}
            title={intl.formatMessage({
              id: "ZFx66U",
              defaultMessage: "Something went wrong",
              description:
                "Error message title when fetching auth session URL fails",
            })}
          />
          <ButtonV2
            onPress={query.refetch}
            title={intl.formatMessage({
              id: "T4E2Fv",
              defaultMessage: "Try Again!",
              description: "Button to retry fetching auth session URL",
            })}
          />
        </View>
      </Screen>
    );
  }

  assert(query.data, "Query data should be defined");

  return (
    <Screen withBottomInset withTopInset preventScroll>
      <Layout>
        <Container
          title={intl.formatMessage({
            id: "H3OeAm",
            defaultMessage: "My Pets",
            description: "Title for the my pets page",
          })}
        >
          <View style={{ gap: styleConstantsV2.spacing16 }}>
            {query.data.map((pet) => {
              return (
                <PetCard
                  key={pet.id}
                  pet={pet}
                  onPress={() => {
                    router.push(`/my-pets/${pet.id}`);
                  }}
                />
              );
            })}
          </View>
        </Container>
      </Layout>
    </Screen>
  );
});
